import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDeskOffice2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"desk-office-2"} maskId="square-filled-radius-0-stroke-1-IconDeskOffice2"><path fillRule="evenodd" clipRule="evenodd" d="M5 3H15V10H10.5V11H21V21H12.25V12H4V21H3V11H9.5V10H5V3ZM20 12V15.5H13.25V12H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDeskOffice2;
